(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sortSelect = document.getElementById('SortBy');
    sortSelect.addEventListener('change', function () {
      const base = this.value;
      const from = new URL(window.location.href);
      const to   = new URL('?sort_by='+base, window.location.href);
      
      from.searchParams.forEach(function(val, key){
        if (key !== 'page' && key !== 'sort_by') {
          to.searchParams.append(key, val);
        }
      });
      window.location.href = to.toString();
    });
  })();

  (function(){
    var spCategorySlect = document.getElementById('filter-products');
    if(!spCategorySlect) return;
    spCategorySlect.addEventListener('change',function () {
      const base = this.value;
      const to   = new URL(base, window.location.href);
      window.location.href = to.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid_2"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var sortSelect = document.getElementById('SortBy');
    sortSelect.addEventListener('change', function () {
      const base = this.value;
      const from = new URL(window.location.href);
      const to   = new URL('?sort_by='+base, window.location.href);
      
      from.searchParams.forEach(function(val, key){
        if (key !== 'page' && key !== 'sort_by') {
          to.searchParams.append(key, val);
        }
      });
      window.location.href = to.toString();
    });
  })();

  (function(){
    var spCategorySlect = document.getElementById('filter-products');
    if(!spCategorySlect) return;
    spCategorySlect.addEventListener('change',function () {
      const base = this.value;
      const to   = new URL(base, window.location.href);
      window.location.href = to.toString();
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
